@if (extensionHuntGroup?.displayName) {
  <h5>Display Name</h5>
  <div class="extension-detail-item">{{ extensionHuntGroup?.displayName }}</div>
}
<ng-container>
  <h5>Ring Timeout</h5>
  <div class="extension-detail-item">{{ extensionHuntGroup?.ringTimeout }}</div>
</ng-container>
<ndt-extension-detail-link
  [extension]="extensionHuntGroup?.routeBusyExtension"
  [header]="'Route Busy Extension'"
></ndt-extension-detail-link>
<ndt-extension-detail-link
  [extension]="extensionHuntGroup?.routeNoAnswerExtension"
  [header]="'Route No Answer Extension'"
></ndt-extension-detail-link>
